// React Imports
import * as React from "react";
import {useState, useEffect, createContext} from "react";
import 'react-format-currency';
import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import {GridToolbarContainer, GridToolbarExport} from '@mui/x-data-grid';
import {
    Avatar,
    Stack,
    Tooltip
} from "@mui/material";
import {blue, brown, deepOrange, deepPurple, lightGreen, teal} from "@mui/material/colors";
import {DataGridPro, GRID_DETAIL_PANEL_TOGGLE_FIELD} from "@mui/x-data-grid-pro";
import Box from "@mui/material/Box";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Typography from "@mui/material/Typography";
import Badge from "@mui/material/Badge";
import ReorderIcon from "@mui/icons-material/Reorder";

// App Imports
import {
    getContractSectionCDP, orderCDPinCS
} from "../../ContractDataPoint/ContractDataPointClient";
import {changeContractDrilldownCDP} from "./contractDrilldownSliceCDP";
import {changeContractDataPoint} from "../../ContractDataPoint/contractDataPointSlice";
import ContractDataPointValueDrawer from "../../ContractDataPointValue/ContractDataPointValueDrawer";
import {changeContractDataPointValue} from "../../ContractDataPointValue/contractDataPointValueSlice";
import ContractDrilldownCdpGridMenu from "./ContractDrilldownCdpGridMenu";
import {getCDPVbyCDPid} from "../../ContractDataPointValue/ContractDataPointValueClient";
import {getCDPVFbyCDPid} from "../../ContractDataPointValueFilter/ContractDataPointValueFilterClient";
import {changeContractDataPointValueFilter} from "../../ContractDataPointValueFilter/contractDataPointValueFilterSlice";
import {changeContractDrilldownCDPV} from "../ContractDrilldownCDPV/contractDrilldownSliceCDPV";
import {changeContractDrilldownCDPVF} from "../ContractDrilldownCDPVF/contractDrilldownSliceCDPVF";
import CrudSnackbar from "../../CommonComponents/CrudSnackbar";
import CdpInfoDialogue from "./Info/CdpInfoDialogue";
import QueryFinancialsDropdownVersion from "../ContractDrilldownCS/Helpers/LineItems/QueryFinancialsDropdownVersion";
import QueryFinancialsGridVersionWide from "../ContractDrilldownCS/Helpers/LineItems/QueryFinancialsGridVersionWide";
import QueryFinancialsGridVersionNarrow from "../ContractDrilldownCS/Helpers/LineItems/QueryFinancialsGridVersionNarrow";


export const CDPcontext = createContext();


// main function
export default function ContractDrilldownCDPGrid(props) {


    // ****************** BEGIN STATES ****************************

    const [drilldownCDP, setDrilldownCDP] = useState([]);
    const [allCDPs, setAllCDPs] = useState([]);
    const [filteredCDP, setFilteredCDP] = useState([]);
    const [drilldownCDPV, setDrilldownCDPV] = useState(null);
    const [showCdpvGrid, setShowCdpvGrid] = useState(false);
    const [showCdpvfGrid, setShowCdpvfGrid] = useState(false);
    const [cdpInfoOpen, setCdpInfoOpen] = useState(false);

    // ****************** END STATES ****************************


    // *********************** BEGIN STORE ********************************

    const expandedCdpId  = useSelector((state) => state.contractDrilldownSlcExpandCS.value.cdpId);
    const selectorCDPId = useSelector((state) => state.contractDataPointValueSlc.value.contractDataPointId);
    const selectorContractSectionId = useSelector((state) => state.contractSectionSlc.value.id);

    const selectorContractGridAPI = useSelector((state) => state.contractSlc.value.contractGridAPI);
    const selectorCdpGridRefresh = useSelector((state) => state.contractSlc.value.cdpGridRefresh);

    const selectorContractDataPointGridRefresh = useSelector(
        (state) => state.contractDataPointSlc.value.cdpGridRefresh
    );

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    const hideActions = localStorage.getItem('hideActions') === "true";


    // ****************** BEGIN FETCH ****************************


    const fetchDrilldownCDP = React.useCallback(() => {
        if (!selectorContractSectionId) return Promise.resolve();

        return getContractSectionCDP(selectorContractSectionId)
            .then(data => {
                console.log("fetchDrilldownCDP");
                console.log(data);

                setDrilldownCDP(data);
                setAllCDPs(data);
                setFilteredCDP(data);

                return data;
            });
    }, [selectorContractSectionId]);

    useEffect(() => {
        fetchDrilldownCDP();
    }, [fetchDrilldownCDP]);

    useEffect(() => {
        if (selectorContractDataPointGridRefresh !== true) return;

        fetchDrilldownCDP().finally(() => {
            dispatchData(changeContractDataPoint({ cdpGridRefresh: false }));
        });
    }, [selectorContractDataPointGridRefresh, fetchDrilldownCDP, dispatchData]);

    // const fetchDrilldownCDP = () =>
    //     getContractSectionCDP(selectorContractSectionId)

    //         .then(data => {
    //                         console.log(data);
    //                         setDrilldownCDP(data);
    //                         setAllCDPs(data);
    //                         setFilteredCDP(data);
    //         })

    // const fetchDrilldownCDP = React.useCallback(() => {
    //     if (!selectorContractSectionId) return Promise.resolve();
    //
    //     return getContractSectionCDP(selectorContractSectionId)

    //         .then(data => {
    //             console.log("fetchDrilldownCDP");
    //             console.log(data);
    //             setDrilldownCDP(data);
    //             setAllCDPs(data);
    //             setFilteredCDP(data);
    //         });
    // }, [selectorContractSectionId]);
    //
    //
    // useEffect(() => {
    //     // console.log("My CDP is loading so far...");
    //     fetchDrilldownCDP();
    // }, [fetchDrilldownCDP]);
    //
    // useEffect(() => {
    //     if (!selectorCdpGridRefresh) return;
    //
    //     fetchDrilldownCDP().finally(() => {
    //         dispatchData(changeContractDataPoint({ cdpGridRefresh: false }));
    //     });
    // }, [selectorCdpGridRefresh, fetchDrilldownCDP, dispatchData]);

    // const lastInitialFetchKeyRef = React.useRef(null);
    //
    // const fetchDrilldownCDP = React.useCallback((force = false) => {
    //     if (!selectorContractSectionId) return Promise.resolve();
    //
    //     if (!force && lastInitialFetchKeyRef.current === selectorContractSectionId) {
    //         return Promise.resolve();
    //     }
    //
    //     if (!force) {
    //         lastInitialFetchKeyRef.current = selectorContractSectionId;
    //     }
    //
    //     return getContractSectionCDP(selectorContractSectionId)
    //         .then(data => {
    //             console.log("fetchDrilldownCDP");
    //             console.log(data);
    //
    //             setDrilldownCDP(data);
    //             setAllCDPs(data);
    //             setFilteredCDP(data);
    //
    //             return data;
    //         });
    // }, [selectorContractSectionId]);
    //
    //
    // useEffect(() => {
    //     fetchDrilldownCDP(false);
    // }, [fetchDrilldownCDP]);
    //
    //
    // useEffect(() => {
    //     if (!selectorCdpGridRefresh) return;
    //
    //     fetchDrilldownCDP(true).finally(() => {
    //         dispatchData(changeContractDataPoint({ cdpGridRefresh: false }));
    //     });
    // }, [selectorCdpGridRefresh, fetchDrilldownCDP, dispatchData]);

    // const currentContractSectionIdRef = React.useRef(null);
    // const initialFetchDoneRef = React.useRef(new Set());
    //
    // useEffect(() => {
    //     currentContractSectionIdRef.current = selectorContractSectionId;
    // }, [selectorContractSectionId]);
    //
    //
    // const fetchDrilldownCDP = React.useCallback((contractSectionId) => {
    //     if (!contractSectionId) return Promise.resolve();
    //
    //     console.log("fetchDrilldownCDP triggered for contractSectionId =", contractSectionId);
    //
    //     return getContractSectionCDP(contractSectionId)
    //         .then(data => {
    //             console.log("fetchDrilldownCDP data");
    //             console.log(data);
    //
    //             setDrilldownCDP(data);
    //             setAllCDPs(data);
    //             setFilteredCDP(data);
    //
    //             return data;
    //         });
    // }, []);
    //
    //
    // useEffect(() => {
    //     if (!selectorContractSectionId) return;
    //
    //     if (initialFetchDoneRef.current.has(selectorContractSectionId)) {
    //         return;
    //     }
    //
    //     initialFetchDoneRef.current.add(selectorContractSectionId);
    //
    //     fetchDrilldownCDP(selectorContractSectionId);
    // }, [selectorContractSectionId, fetchDrilldownCDP]);
    //
    //
    // useEffect(() => {
    //     console.log("selectorCdpGridRefresh changed =", selectorCdpGridRefresh);
    //
    //     if (!selectorCdpGridRefresh) return;
    //
    //     const contractSectionId = currentContractSectionIdRef.current;
    //
    //     fetchDrilldownCDP(contractSectionId).finally(() => {
    //         dispatchData(changeContractDataPoint({ cdpGridRefresh: false }));
    //     });
    // }, [selectorCdpGridRefresh, fetchDrilldownCDP, dispatchData]);

//
//     const [cdpReloadSeq, setCdpReloadSeq] = React.useState(0);
//     const lastFetchKeyRef = React.useRef(null);
//
//     const fetchDrilldownCDP = React.useCallback((contractSectionId) => {
//         if (!contractSectionId) return Promise.resolve();
//
//         return getContractSectionCDP(contractSectionId)
//             .then(data => {
//                 console.log("fetchDrilldownCDP");
//                 console.log(data);
//
//                 setDrilldownCDP(data);
//                 setAllCDPs(data);
//                 setFilteredCDP(data);
//
//                 return data;
//             });
//     }, []);
//
//
// // Redux refresh flag only bumps the local reload counter
//     useEffect(() => {
//         if (!selectorCdpGridRefresh) return;
//
//         setCdpReloadSeq(prev => prev + 1);
//
//         dispatchData(changeContractDataPoint({
//             cdpGridRefresh: false
//         }));
//     }, [selectorCdpGridRefresh, dispatchData]);
//
//
// // One controlled fetch effect
//     useEffect(() => {
//         if (!selectorContractSectionId) return;
//
//         const fetchKey = `${selectorContractSectionId}-${cdpReloadSeq}`;
//
//         // Prevent duplicate StrictMode / duplicate mount fetch for the exact same request
//         if (lastFetchKeyRef.current === fetchKey) return;
//
//         lastFetchKeyRef.current = fetchKey;
//
//         fetchDrilldownCDP(selectorContractSectionId);
//     }, [selectorContractSectionId, cdpReloadSeq, fetchDrilldownCDP]);
//
//     function fetchDrilldownCDP() {
//         if (!selectorContractSectionId) return Promise.resolve();
//
//         return getContractSectionCDP(selectorContractSectionId)
//             .then(data => {
//                 console.log("fetchDrilldownCDP");
//                 console.log(data);
//
//                 setDrilldownCDP(data);
//                 setAllCDPs(data);
//                 setFilteredCDP(data);
//
//                 return data;
//             });
//     }
//
//
//     useEffect(() => {
//         fetchDrilldownCDP();
//     }, [selectorContractSectionId]);
//
//
//     useEffect(() => {
//         if (!selectorCdpGridRefresh) return;
//
//         fetchDrilldownCDP().finally(() => {
//             dispatchData(changeContractDataPoint({ cdpGridRefresh: false }));
//         });
//     }, [selectorCdpGridRefresh]);

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************
    //
    // useEffect(() => {
    //     console.log("My CDP is loading so far...");
    //     fetchDrilldownCDP();
    // }, [useSelector((state) => state.contractSectionSlc.value.id)]);
    //
    //
    // useEffect(() => {
    //     if (selectorCdpGridRefresh===false) return;
    //     fetchDrilldownCDP();
    //     dispatchData(changeContractDataPoint({cdpGridRefresh: false}));
    // }, [useSelector((state) => state.contractDataPointSlc.value.cdpGridRefresh)===true]);
    //

    useEffect(() => {
            console.log("drilldownCDPV length outside");
            if(drilldownCDPV !== null) {
                console.log("drilldownCDPV length inside");
                console.log(drilldownCDPV.length);
            }
        },
        [useSelector((state)=> state.contractDataPointSlc.value.id)]
    );

    // ******************** END USE EFFECTS *******************


    function DetailPanelContent() {
        return (
            <h2>TEST</h2>
        )}


    const handleOrder = () => {
        console.log("ordering the contract data points for section: ",selectorContractSectionId );
        orderCDPinCS(selectorContractSectionId).then(() =>
            dispatchData(changeContractDataPoint({cdpGridRefresh: true})))
    };


    const handleCdpInfo = () => {
        setCdpInfoOpen(true);
    };

    const handleCloseCdpInfo = () => {
        setCdpInfoOpen(false);
    };


    // ***************** BEGIN CONTROLS ***************************

    const handleAdd = () => {
        dispatchData(changeContractDataPoint({
            id: 0,  contractSectionId: Number(selectorContractSectionId), ordinalNumber: null, dataPointId: null,
            contractLevel: null, destinationFolder: null, versionInd: false, versionNumber: null, cycleInd: null,cycleNumber: null,
            calcGroup: null, calcWave: null,
            sourceContractSectionId: null, sourceContractDataPointId: null,
            status: null,
            mockIndicator: null, mockValue: null, mockOrigin: null, mockExpression: null, mockExpressionTranslation: null,
            randomized: false,
            createdOn: null,createdBy: null,lastModifiedOn: null,lastModifiedBy: null,
            cdpDrawerState: true, cdpDrawerMode: "Add"}));

    };

    const handleEditValue = (row) => {
        if(row.cdpvCount === 1) {
            console.log("trying to edit cdpv from ordinal number");
            console.log("row.cdpvCount === 1");
            // console.log("calling handleClickedRow");
            // handleClickedRow(row);
            // console.log("handleClickedRow completed");
            console.log("dispatching cdpv data");
            dispatchData(changeContractDataPointValue({
                id: row.cdpvId, contractDataPointId: row.id,
                mockValue:row.mockValue,
                origin: row.mockOrigin,
                expression: row.mockExpression,
                expressionDescription: row.mockExpressionDescription,
                contractDataPointValueFilterId: row.cdpvfId,
                ordinalNumber: row.ordinalNumber, iterationNumber: row.iterationNumber,
                extendInd: row.extendInd, value: row.value,
                // expression: res.data[0].expression, expressionDescription: res.data[0].expressionDescription,
                //  expressionTranslation: res.data[0].expressionTranslation,
                //  sourceContractDataPointValueId: res.data[0].sourceContractDataPointValueId,
                // status: res.data[0].status,
                //
                //  createdOn: res.data[0].createdOn,createdBy: res.data[0].createdBy,
                //  lastModifiedOn: res.data[0].lastModifiedOn,lastModifiedBy: res.data[0].lastModifiedBy,
                //  defaultValue: res.data[0].defaultValue,

                cdpvDrawerState: true,  cdpvDrawerContext: "cdpGrid",cdpvDrawerMode: "Edit", cdpvViewValueOnly: true}));
        }
        if(row.cdpvCount > 1) {
            dispatchData(changeContractDrilldownCDP({id: row.id}));
            dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
            dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "Edit"}));
        }
    };

    const handleMousedRow = (row) => {
        console.log("handleMousedRow called");
        console.log("calling handleClickedRow");
        handleClickedRow(row);
        console.log("handleClickedRow completed");
    };

    const handleClickedRow = (cdpData) => {
        console.log('CDP data from clicked row');
        console.log(cdpData);
        dispatchData(changeContractDrilldownCDP({id: cdpData.id, filterId: null}));
        dispatchData(changeContractDataPoint({id: cdpData.id, contractSectionId: cdpData.contractSectionId,
            ordinalNumber: cdpData.ordinalNumber, dataPointId: cdpData.dataPointId,
            dataType: cdpData.dataType, dataPointName: cdpData.dataPointName,
            contractLevel: cdpData.contractLevel, destinationFolder: cdpData.destinationFolder,
            versionInd: cdpData.versionInd, versionNumber: cdpData.versionNumber,
            cycleInd: cdpData.cycleInd, cycleNumber: cdpData.cycleNumber,
            calcGroup: cdpData.calcGroup, calcWave: cdpData.calcWave,
            sourceContractSectionId: cdpData.sourceContractSectionId, sourceContractDataPointId: cdpData.sourceContractDataPointId,
            status: cdpData.status,
            mockIndicator: cdpData.mockIndicator, mockValue: cdpData.mockValue, mockOrigin: cdpData.mockOrigin,
            mockExpression: cdpData.mockExpression, mockExpressionTranslation: cdpData.mockExpressionTranslation,
            randomized: cdpData.randomized,
            cdpvCount: cdpData.cdpvCount, cdpvfCount: cdpData.cdpvfCount,
            cdpvId: cdpData.cdpvId, cdpvfId: cdpData.cdpvfId, cdpvCdpvfId: cdpData.cdpvCdpvfId,
            createdOn: cdpData.createdOn,createdBy: cdpData.createdBy,
            lastModifiedOn: cdpData.lastModifiedOn,lastModifiedBy: cdpData.lastModifiedBy        }))
        getCDPVbyCDPid(cdpData.id)
            .then(function(res){
                dispatchData(changeContractDataPointValue({cdpvCount: res.length
                    // , cdpvDrawerMode: "View"
                }));
                if(res.length===1) {
                    console.log("get cdpv data")
                    console.log(res[0])
                    dispatchData(changeContractDataPointValue(
                            {id: res[0].id
                                ,
                                contractDataPointId: res[0].contractDataPointId,
                                contractDataPointValueFilterId: res[0].contractDataPointValueFilterId,
                                ordinalNumber: res[0].ordinalNumber, iterationNumber: res[0].iterationNumber,
                                extendInd: res[0].extendInd, value: res[0].value,
                                expression: res[0].expression, expressionDescription: res[0].expressionDescription,
                                expressionTranslation: res[0].expressionTranslation,
                                sourceContractDataPointValueId: res[0].sourceContractDataPointValueId,
                                origin: res[0].origin, status: res[0].status,
                                mockValue: res[0].mockValue,
                                createdOn: res[0].createdOn,createdBy: res[0].createdBy,
                                lastModifiedOn: res[0].lastModifiedOn,lastModifiedBy: res[0].lastModifiedBy,
                                defaultValue: res[0].defaultValue
                            }
                        )
                    )
                }
            });
        console.log("my cdpv.cpd.id")
        console.log(selectorCDPId)
        getCDPVFbyCDPid(cdpData.id)
            .then(function(res){
                if(res.length===1) {
                    console.log("my cdpvf")
                    console.log(res[0])
                    dispatchData(changeContractDataPointValueFilter(
                            {id: res[0].id,
                                contractDataPointId: res[0].contractDataPointId,
                                parentFilterId: res[0].parentFilterId,
                                previousFilterId: res[0].previousFilterId,
                                ordinalNumber: res[0].ordinalNumber,
                                recordLevel: res[0].recordLevel,
                                dataPointId: res[0].dataPointId,
                                dataPointName: res[0].dataPointName,
                                dataType: res[0].dataType,
                                singleValue: res[0].singleValue,
                                mockValue: res[0].mockValue,
                                fromValue: res[0].fromValue,
                                toValue: res[0].toValue,
                                status: res[0].status,
                                hierarchy: res[0].hierarchy,
                                cdpvMockValue: res[0].cdpvMockValue,
                                expressionIndicator: res[0].expressionIndicator,
                                mockExpression: res[0].mockExpression,
                                mockExpressionTranslation: res[0].mockExpressionTranslation,
                                cdpvCount: res[0].cdpvCount,
                                createdOn: res[0].createdOn,
                                createdBy: res[0].createdBy,
                                lastModifiedOn: res[0].lastModifiedOn,
                                lastModifiedBy: res[0].lastModifiedBy
                            }
                        )
                    )
                }
            });
    }


    const handleExploreCDPVF = (selectedCDP, rowElement, rowFull) => {
        setShowCdpvfGrid(!showCdpvfGrid);
        console.log("Here's the grid state upon clicking the f button");
        console.log(showCdpvfGrid);
        dispatchData(changeContractDrilldownCDP({id: selectedCDP, filterId: null}));
        // dispatchData(changeContractDataPointValueFilter({cdpvfGridState: true}));
        dispatchData(changeContractDrilldownCDPVF({cdpvfGridState: true}));
    }


    const handleExploreCDPV = (selectedCDP, rowElement, rowFull) => {
        setShowCdpvGrid(!showCdpvGrid);
        console.log("Here's the grid state upon clicking the m button");
        console.log(showCdpvGrid);
        dispatchData(changeContractDrilldownCDP({id: selectedCDP, filterId: null}));
        dispatchData(changeContractDataPointValue({cdpvGridState: true, cdpvDrawerMode: "View"}));
        dispatchData(changeContractDrilldownCDPV({cdpvGridState: true}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN COLUMNS ***************************

    const columns = fetchDrilldownCDP => [
        {
            field: "more",
            headerName: '',
            width: 30,
            padding: 0,
            margin: 0,
            sortable: false,
            menu: false,
            filter: false,
            hide: hideActions,
            renderCell: (contractDataPoints) => {
                return (
                    <ContractDrilldownCdpGridMenu/>

                );
            }

        },

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            width: 60,
            hide: true,
        },
        {
            field: 'contractSectionId',
            headerName: 'cs',
            description: '',
            sortable: true,
            width: 30,
            hide: true,
        },
        {
            field: 'cycleNumber',
            headerName: 'Cycle',
            description: '',
            sortable: true,
            width: 50,
            hide: true,
        },
        {
            field: 'ordinalNumber',
            headerName: '#',
            description: '',
            sortable: false,
            // editable: true,
            width: 30,
            renderCell: (filteredCDP) => {
                const showBadge = (selectorContractGridAPI === "PartsAbstracts"
                    && filteredCDP.row.mockOrigin === "Input"
                    // && filteredCDP.row.mockValue === null
                ); // your condition

                const content = (
                    <Box sx={{display: 'inline-block', cursor: 'pointer'}}>
                        {filteredCDP.row.ordinalNumber}
                    </Box>
                );

                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Contract Data Point ID: " + filteredCDP.row.id}>
                        {showBadge ? (
                            <Badge
                                onMouseOver = {() => handleMousedRow(filteredCDP.row)}
                                onClick={() => handleEditValue(filteredCDP.row)}
                                variant="dot"
                                color= {filteredCDP.row.mockValue === null && filteredCDP.row.cdpvCount === 1 ? "error" : "success"}
                                overlap="rectangular"
                                anchorOrigin={{vertical: 'top', horizontal: 'right'}}
                                sx={{
                                    "& .MuiBadge-badge": {
                                        transform: "translate(10px, 0px)",
                                    },
                                }}
                            >
                                {content}
                            </Badge>
                        ) : (
                            content
                        )}
                    </Tooltip>
                );
            }
        },
        // {
        //     field: 'ordinalNumber',
        //     headerName: '#',
        //     description: '',
        //     sortable: false,
        //     // editable: true,
        //     width: 30,
        //     renderCell: (filteredCDP) => {
        //         return <Tooltip   enterDelay={1000}  title={"Contract Data Point ID: " + filteredCDP.row.id}>
        //             <Box sx={{ display: 'flex', alignItems: 'center' }}>
        //         <div className="rowitem" style={{cursor:'pointer'}}
        //         >
        //             {filteredCDP.row.ordinalNumber}</div>
        //             <Tooltip  enterDelay={1000}  title={"Input Needed"}>
        //                         <Badge badgeContent={0} color="error">
        //                         </Badge>
        //             </Tooltip>
        //             </Box>
        //         </Tooltip>;},
        // },
        {

            field: 'dataPointName',
            headerName: 'Name',
            renderCell: (filteredCDP) => {
                return <Tooltip  placement={'right-start'}  enterDelay={1000}  enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"Data Point Name: " + filteredCDP.row.dataPointName +
                        "\nData Point Description: " + filteredCDP.row.dataPointDescription +
                        "\nData Point ID: " + filteredCDP.row.dataPointId +
                        "\nVersion: " + filteredCDP.row.versionInd +
                        "\nCycle: " + filteredCDP.row.cycleInd +
                        "\nIteration: " + filteredCDP.row.mockIterationNumber +
                        "\nExtend last iteration: " + filteredCDP.row.mockExtendInd
                    }
                </span>}>
                    <div className="rowitem" style={{cursor:'pointer',
                        backgroundColor: filteredCDP.row.id === expandedCdpId ? 'yellow' : 'transparent',
                    }}
                         onClick={() => handleEditValue(filteredCDP.row)}
                    >
                        {filteredCDP.row.dataPointName}</div></Tooltip>;},
            description: '',
            sortable: false,
            width: 280,
        },
        {
            field: 'mockValue',
            headerName: 'Value',
            description: '',
            sortable: false,
            width: 300,
            renderCell: (filteredCDP) =>
            {
                // if no cdpv
                if((filteredCDP.row.cdpvCount === 0) && (filteredCDP.row.cdpvfCount === 0)){
                    return (
                        <Tooltip   enterDelay={1000}  enterNextDelay={1000} title={"A value record must be added, even if it is empty for user input."}>
                            <p style = {{fontStyle: "italic"}}>missing value record(s)</p>
                            {/*sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>{filteredCDP.row.mockIndicator} </Avatar>*/}
                        </Tooltip>)}
                // if one cdpv and no cdpvf and no default
                if((filteredCDP.row.cdpvCount === 1) && (filteredCDP.row.cdpvfCount === 0)
                    && (filteredCDP.row.randomized !== true)
                    // &&
                    // (filteredCDP.row.defaultValue === null)  || (filteredCDP.row.defaultValue === '')
                )
                {
                    return <Tooltip  style={{cursor:'pointer'}} placement={'right-start'}  enterDelay={1000}  enterNextDelay={1000} title={<span style={{whiteSpace: 'pre-line'}}>
                    {"A single value is present" +
                        "\nValue: " + filteredCDP.row.cdpvValue  +
                        "\nName: " + filteredCDP.row.mockValue }
                </span>}>
                        <div>{filteredCDP.row.mockValue}</div>
                    </Tooltip>;
                }
                // if one cdpv and no cdpvf and there is a default value
                // if((filteredCDP.row.cdpvCount === 1) && (filteredCDP.row.cdpvfCount === 0)
                //     && (filteredCDP.row.defaultValue !== null)  && (filteredCDP.row.defaultValue !== ''))
                // {
                //     return (
                //         <Tooltip   enterDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                //     {"A default value is present" +
                //         "\nDefault Value: " + filteredCDP.row.defaultValue }
                // </span>}>
                //             <Avatar
                //                 sx={{ height:20, width: 20, fontSize: 16, bgcolor: blue[500] }}>d</Avatar>
                //         </Tooltip>)}

                if(
                    (filteredCDP.row.cdpvCount === 1) && (filteredCDP.row.cdpvfCount === 0)
                    &&
                    filteredCDP.row.randomized === true
                    // && ((filteredCDP.row.defaultValue === null)  || (filteredCDP.row.defaultValue === ''))
                    && ((filteredCDP.row.mockValue === null)  || (filteredCDP.row.mockValue === ''))

                )
                {
                    return (
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={<span style={{whiteSpace: 'pre-line'}}>
                    {"This data point is set to be randomized for testing." }
                </span>}>
                            <Avatar
                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: brown[500] }}>r</Avatar>
                        </Tooltip>)}

                // if multiple cdpv and no filters
                if((filteredCDP.row.cdpvCount > 1) && (filteredCDP.row.cdpvfCount === 0)){
                    return (
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"Multiple values.  Click to see all."}>
                            <Avatar
                                onClick= {() => handleExploreCDPV(filteredCDP.row.id,  filteredCDP.row)}
                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepPurple[500] }}>m</Avatar>
                        </Tooltip>)}
                // if cdpv filters exist
                if(filteredCDP.row.cdpvfCount > 0){
                    // if(filteredCDP.row.mockIndicator==='f'){
                    return (
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"Filtered values.  Click to see all."}>
                            <Avatar
                                onClick= {() => handleExploreCDPVF(filteredCDP.row.id,  filteredCDP.row)}
                                sx={{ height:20, width: 20, fontSize: 16, bgcolor: teal[500] }}>f</Avatar>
                        </Tooltip>)}

            },
        },
        {
            field: GRID_DETAIL_PANEL_TOGGLE_FIELD,
            type: 'actions',  // Required for built-in expand behavior
            headerName: 'Exp',
            renderCell: (filteredCDP) =>
            {
                if((filteredCDP.row.mockExpression !== null) && (filteredCDP.row.mockExpression !== '')){

                    return (
                        <Tooltip   enterDelay={1000} enterNextDelay={1000}  title={"Value comes from an expression.  Click to see."}>
                            <Avatar sx={{ height:20, width: 20, fontSize: 16, bgcolor: deepOrange[500] }}>e</Avatar>
                        </Tooltip>)}
            },
            description: '',
            sortable: false,
            width: 50,
        },

        {
            field: 'versionInd',
            headerName: 'Version',
            description: '',
            sortable: false,
            width: 100,
            hide: true
        },
        {
            field: 'mockOrigin',
            headerName: 'Origin',
            description: '',
            sortable: false,
            width: 80,
        },

        {
            field: 'contractLevel',
            headerName: 'Level',
            description: '',
            sortable: false,
            defaultValue: 'All',
            width: 120,
        },
        {
            field: 'destinationFolder',
            headerName: 'Folder',
            description: '',
            sortable: false,
            defaultValue: 'All',
            width: 130,
        },
    ]

    // *************** END COLUMNS *******************************



    const getDetailPanelHeight = React.useCallback(() => 300, []);

    const getDetailPanelContent = React.useCallback(
        ({ row }) => <DetailPanelContent row={filteredCDP.id} />,
        [],
    );


    // ****************** BEGIN RETURN ****************************

    return (
        <div style={{ height: '100%' , width: '100%' }}>
            {useSelector((state) => state.contractDataPointValueSlc.value.cdpvDrawerContext) === "cdpGrid" &&
                <ContractDataPointValueDrawer/>}
            <CdpInfoDialogue
                open={cdpInfoOpen}
                onClose={handleCloseCdpInfo}
                selectorContractGridAPI={selectorContractGridAPI}
            />

            <Stack direction="row" spacing={2}>
                <Box>
                    {selectorContractGridAPI !== "Dashboards" &&
                        <Tooltip enterDelay={1000} enterNextDelay={1000} title="Relevant Data Points contained in this Contract Section">
                            <Typography style={{cursor:'pointer'}} sx={{ fontWeight: 'bold'
                            }} onClick={() => handleCdpInfo()} >Contract Data Points</Typography>
                        </Tooltip>
                    }
                    {selectorContractGridAPI === "Dashboards" &&
                        <Tooltip enterDelay={1000} title="Data Points to be displayed in the Dashboard results">
                            <Typography style={{cursor:'pointer'}} sx={{ fontWeight: 'bold'
                            }} onClick={() => handleCdpInfo()} >Returned Data Points</Typography>
                        </Tooltip>
                    }
                </Box>
                {!hideActions &&
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title="Add New Data Point">
                        <Box              sx={{alignItems: 'bottom',  pb: 0, mr: 3, mb: 0, verticalAlign: 'bottom'}}
                                          style={{cursor:'pointer'}}
                                          onClick={() => handleAdd()}>
                            <AddCircleOutlineIcon  sx={{my:0 }}  fontSize="medium" color={'primary'}
                            />
                        </Box>
                    </Tooltip>
                }
                {/*{!hideActions &&*/}
                <Tooltip enterDelay={1000} enterNextDelay={1000} title="Reorder Data Points">
                    <Box              sx={{alignItems: 'bottom',  pb: 0, mr: 3, mb: 0, verticalAlign: 'bottom'}}
                                      style={{cursor:'pointer'}}
                                      onClick={() => handleOrder()}>
                        <ReorderIcon  sx={{my:0 }}  fontSize="medium" color={'primary'}
                        />
                    </Box>
                </Tooltip>
                {/*}*/}
            </Stack>
            <DataGridPro
                style={{ height: '100%' , width: '100%' }}
                aria-label={"ContractDataPoints2"}
                rows={filteredCDP}
                sx={{
                    '& .MuiDataGrid-detailPanel': {
                        backgroundColor: deepOrange[100],
                    },
                    // '& .level--1': { backgroundColor: "rgb(30,144,255)" },
                    // ... // your other styles
                }}
                onRowClick = {(filteredCDP)=>handleClickedRow(filteredCDP.row)}
                rowThreshold={0}
                // getDetailPanelHeight={getDetailPanelHeight}
                getDetailPanelContent={({ row }) => (
                    <Box sx={{ p: 2,
                        bgcolor: deepOrange[100]
                        // backgroundColor: "rgb(255,204,153)"
                    }}>
                        <Box sx={{ml: 2}}>
                            <strong>Expression:</strong> {row.mockExpression}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Translation:</strong> {row.mockExpressionTranslation}
                        </Box>
                        <br/>
                        <Box sx={{ml: 2}}>
                            <strong>Description:</strong> {row.mockExpressionDescription}
                        </Box>
                    </Box>
                )}
                getDetailPanelHeight={getDetailPanelHeight}
                // getDetailPanelHeight={({ row }) => {
                //     const lineHeight = 24;
                //     const padding = 32;
                //     const lines = [
                //         row.mockExpression,
                //         row.mockExpressionTranslation,
                //     ].filter(Boolean).length;
                //     return padding + lines * lineHeight + 16;
                // }}
                disableDensitySelector={true}
                disableColumnSelector={true}
                columns={columns(fetchDrilldownCDP)}
                density={"compact"}
                pageSize={50}
                rowsPerPageOptions={[50]}
                hideFooter = {true}
                initialState={{
                    sorting: {
                        sortModel: [{ field: 'ordinalNumber', sort: 'asc' }],
                    },
                }}
            />
        </div>
    );

    // ****************** END RETURN ****************************


}



